import { type FC } from 'react';
import { Router } from '~/core/navigation/Router';
// import { setupFirebase } from '~/lib/firebase';
// import { useEffect } from 'react';
// import { getAuth, onAuthStateChanged } from 'firebase/auth';
// import { useSignIn, useSignOut } from '~/components/contexts/UserContext';

const Main: FC = (): JSX.Element => (
  //   const { signIn } = useSignIn();
  //   const { signOut } = useSignOut();
  //   useEffect(() => {
  //     setupFirebase();

  //     const auth = getAuth();

  //     onAuthStateChanged(auth, (user) => {
  //       if (user) {
  //         signIn(user);
  //       } else {
  //         signOut();
  //       }
  //     });
  //   }, []);
  <Router />
);

export default Main;
